import { render } from "./ReviewView.vue?vue&type=template&id=0cabf3d3&scoped=true&ts=true"
import script from "./ReviewView.vue?vue&type=script&lang=ts"
export * from "./ReviewView.vue?vue&type=script&lang=ts"

import "./ReviewView.vue?vue&type=style&index=0&id=0cabf3d3&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cabf3d3"]])

export default __exports__